import React from 'react'
import { getCurrentLangKey } from 'ptz-i18n'
import { StaticQuery, graphql } from "gatsby"
import { IntlProvider } from 'react-intl';

import 'intl';
import './index.scss'

const Layout = ({ children, location, i18nMessages, fullScreen = true }) => {
  return (
    <StaticQuery
      query={graphql`
        query LayoutQuery {
          site {
            siteMetadata {
              languages {
                defaultLangKey
                langs
              }      
            }
          }
        }
      `}
      render={data => {
        const url = location.pathname;
        const { langs, defaultLangKey } = data.site.siteMetadata.languages;
        const langKey = getCurrentLangKey(langs, defaultLangKey, url);
        
        return (
          <IntlProvider
            locale={langKey}
            messages={i18nMessages}>
            <div style={{ minHeight: '100%' }} className={fullScreen ? 'margin-top-page' : 'site-content'}>
              {children}
            </div>
          </IntlProvider>
        )
      }}
    />
  );
};

// @media screen and (min-width: 1001px) {
  //   margin-top: 97px;
  // }
  
export default Layout
